import { gql } from "@apollo/client";

export const DISCOUNTS_REPORT = gql`
  query DiscountsReport(
    $where: reports_discounts_bool_exp!
  ) {
    reports_discounts(
      where: $where
    ) {
        org_name
        organization_id
        event_name
        event_id
        vendor_name
        vendor_id
        location_name
        location_id
        username
        discount_name
        discount_type
        discount_value
        discount_count
        transaction_date
        transaction_hour
        transaction_15min
    }
  }
`;
